import React, { useEffect, useState } from "react";
import ButtonGroup from "../../../ui/ButtonGroup/ButtonGroup.js";
import SearchInput from "../../../ui/SearchInput/SearchInput.js";
import CardSlider from "../../../ui/CardSlider/CardSlider.js";
import useDebounce from "../../../hooks/useDebounce";

const CardsList = ({
  cards,
  loading,
  opened,
  type,
  status,
  onTypeChange,
  onStatusChange,
  onTakeOn,
  onTakeOff,
  onSetHidden,
  onSetRatio,
  onSetPacket,
  canTakeOn,
  user,
  term,
  onSearchChange,
  allTypesAllowed,
  permissions
}) => {
  const [search, setSearch] = useState(term || "");
  const debounceSearch = useDebounce(search, 500);

  useEffect(() => {
    onSearchChange(debounceSearch);
  }, [debounceSearch]);

  useEffect(() => {
    setSearch(term || "");
  }, [term]);

  let typeItems = [];

  if (type == "ex") {
    typeItems = [
      { title: "В работе", code: "inwork", count: cards.counts.inwork },
      { title: "В долгах", code: "indebt", count: cards.counts.indebt },
      { title: "Без анонсов", code: "zero", count: cards.counts.zero },
      { title: "Долг свыше 50%", code: "debt50", count: cards.counts.debt50 },
      { title: "Скрытые", code: "hidden", count: cards.counts.hidden },
      { title: "Без долгов", code: "nodebt", count: cards.counts.nodebt }
    ];
  } else if (type == "ad") {
    typeItems = [
      { title: "В работе", code: "inwork", count: cards.counts.inwork },
      { title: "Все", code: "all", count: cards.counts.all }
    ];
  }

  if (!opened) {
    return null;
  }

  return (
    <div className="cards-wrapper">
      <div className="content-body">
        <div className="cards-wrapper__filters">
          {allTypesAllowed && (
            <ButtonGroup
              items={[
                { title: "Обмен", code: "ex" },
                { title: "Реклама", code: "ad" }
              ]}
              selected={type}
              onClick={onTypeChange}
            />
          )}
          <SearchInput
            placeholder="Название или [id]"
            value={search}
            onChange={e => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <div className="cards-wrapper__filters">
          <ButtonGroup
            items={typeItems}
            selected={status}
            onClick={onStatusChange}
          />
        </div>
        <CardSlider
          items={getCardList(status, cards.cards)}
          onTakeOn={onTakeOn}
          onTakeOff={onTakeOff}
          onSetHidden={onSetHidden}
          onSetRatio={onSetRatio}
          onSetPacket={onSetPacket}
          loading={loading}
          canTakeOn={canTakeOn}
          user={user}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

export default CardsList;

const getCardList = (type, cards) => {
  if (type !== "debt50" && type !== "nodebt") {
    return cards;
  }

  return cards.slice().sort((x, y) => {
    if (type === "debt50") {
      return new Date(x.last_teaser_add) - new Date(y.last_teaser_add); // От старых к новым
    }

    if (type === "nodebt") {
      return new Date(y.last_teaser_add) - new Date(x.last_teaser_add); // От новых к старым
    }
  });
};
